export const SET_DEMANDES_EN_ATTENTES = 'SET_DEMANDES_EN_ATTENTES';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
